export default "__VITE_ASSET__6Klhah0C__"